import React, { FC } from 'react';
import classnames from 'classnames';
import { ApplicantsSortOptionEnum } from '@src/graphql/generated';
import { useQueryParams } from '@src/customHooks/useQueryParams';
import { trackEvent } from '@src/metrics';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { QueryParams } from '../../interfaces/queryParams.interface';
import './styles.scss';

const SORT_OPTIONS = [
  {
    label: 'Applied at',
    value: ApplicantsSortOptionEnum.USER_APPLIED_AT,
  },
  {
    label: 'Last message',
    value: ApplicantsSortOptionEnum.LATEST_MESSAGE,
  },
];

export const InShortlistHeader: FC = () => {
  const { queryParams, updateQueryParams } = useQueryParams<QueryParams>();

  const sortOption = queryParams.inShortlistUsersSortOption || ApplicantsSortOptionEnum.USER_APPLIED_AT;

  const onSort = (inShortlistUsersSortOption: ApplicantsSortOptionEnum): void => {
    updateQueryParams({ inShortlistUsersSortOption: inShortlistUsersSortOption });

    trackEvent({
      context: MetricContext.OPENING_VIEW,
      interaction: MetricAction.SORT_FEED,
      payload: {
        'Sort Option': inShortlistUsersSortOption,
      },
    });
  };

  return (
    <div className="opening-in-shortlist-header">
      <div className="opening-in-shortlist-header__text">
        <div className="opening-in-shortlist-header__title">Shortlist</div>

        <div className="opening-in-shortlist-header__description">
          Talents who have accepted the invite to apply and are waiting to start a conversation
        </div>
      </div>

      <div className="opening-in-shortlist-header__sorting-wrapper">
        <span className="opening-in-shortlist-header__sort-by">Sort by:</span>

        <div className="opening-in-shortlist-header__sorting">
          {SORT_OPTIONS.map(option => {
            return (
              <div
                className={classnames(
                  'opening-in-shortlist-header__sorting-option',
                  sortOption === option.value && 'opening-in-shortlist-header__sorting-option--active',
                )}
                key={option.value}
                onClick={() => onSort(option.value)}
              >
                {option.label}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
